export default class PublicReviewActions {
  initializeListeners() {
    $(document).on('ajax:complete', '.upvote-review', (xhr, status) => {
      if (status.status === 200) {
        const $target = $(xhr.target);
        const $counter = $target.next('.text-count').add($target.find('.text-count')).first();

        if ($counter.length > 0) {
          $counter.html(`(${status.responseText})`);
        }
      }
    });

    $(document).on('ajax:complete', '.flag-review', (xhr, status) => {
      if (status.responseText === 'ok') {
        openModal('#review-flagged-modal');
      }
    });

    if ($('body.companies.show').length > 0 && /sort%5Bby/.test(document.location.search) && document.referrer.indexOf("google") < 0) {
      if (document.querySelector("#recent-reviews")){
        window.scrollTo(0, $('#recent-reviews').offset().top);
      }
    }
  }
}
